/* eslint-disable no-dupe-else-if */
import { XPartnerService } from '@shared/services/x-partner.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';
import { NavigateService } from '@core/routes/services/navigate.service';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { of, throwError, timer } from 'rxjs';
import { delay, retryWhen, switchMap } from 'rxjs/operators';
import { UserService } from '@shared/services/user.service';
import { EventsService } from '@shared/services/events.service';

@Component({
  selector: 'df-base-left-side-navigation-footer',
  templateUrl: './base-left-side-navigation-footer.component.html',
  styleUrls: ['./base-left-side-navigation-footer.component.scss'],
})
export class BaseLeftSideNavigationFooterComponent implements OnInit, AfterViewInit {
  @ViewChild('helpCenterList') helpCenterList!: ElementRef;
  helpDropdownOpen = false;
  notificationsCount = '';
  readonly kompassifyWidgetId: string = 'kompassify-notif-widget';
  visibleNovuNotification = false;

  constructor(
    public n: NavigateService,
    public basePanelService: BasePanelService,
    public xPartnerService: XPartnerService,
    private changes: ChangeDetectorRef,
    public userService: UserService,
    private elementRef: ElementRef,
    public eventsService: EventsService,
  ) {}

  ngOnInit(): void {
    this.basePanelService.novuNotoficationsSubject.subscribe({
      next: (val) => (this.visibleNovuNotification = val),
    });
  }

  ngAfterViewInit(): void {
    this.getKompassifyElement().subscribe((elem) => {
      const visibility = elem ? getComputedStyle(elem).display : 'none';
      if (visibility != 'none') {
        this.notificationsCount = elem?.innerHTML.toString();

        this.changes.detectChanges();
      }
    });
  }

  getKompassifyElement() {
    return timer(0).pipe(
      switchMap(() => {
        const widget = document.getElementById(this.kompassifyWidgetId);
        if (!widget || widget.innerHTML === '') {
          return throwError('Error!');
        }
        return of(widget);
      }),
      retryWhen((errors) => errors.pipe(delay(1000))),
    );
  }

  @HostBinding('class.short')
  get short() {
    return this.basePanelService?.routeData?.shortLeftNavigation;
  }

  showNovuNotifications() {
    if (
      this.elementRef.nativeElement.closest('body').querySelector('#kompassify-announcement-player').style.display !=
      'none'
    ) {
      setTimeout(() => {
        this.basePanelService.showNovuNotification(false);
      }, 200);
    } else if (
      this.elementRef.nativeElement.closest('body').querySelector('#kompassify-announcement-player').style.display ==
      'none'
    ) {
      setTimeout(() => {
        this.basePanelService.showNovuNotification(true);
      }, 200);
    } else if (
      this.elementRef.nativeElement.closest('body').querySelector('#kompassify-announcement-player').style.display ==
        'none' &&
      !this.elementRef.nativeElement
        .closest('df-base-panel')
        .querySelector('df-novu-notifications')
        .classList.contains('hidden')
    ) {
      setTimeout(() => {
        this.basePanelService.showNovuNotification(false);
      }, 200);
    }
  }

  // it have to be window.open instead of <a href="">
  // because closing dropdown prevents opening href link
  closeDropdownAndOpenUrl(url: string): void {
    this.helpDropdownOpen = false;
    window.open(url, '_blank');
  }
}
